<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Model Information
                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Name:" label-for="title">
                                    <b-form-input id="title" type="text" placeholder="Enter model name" :state="validateField(title)" autocomplete="off"
                                        v-model="title">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Name:" label-for="brand_id">
                                    <MultiSelect id="brand_id" v-model="brand_id" :options="brands" optionLabel="text" optionValue="value" dataKey="value" filter placeholder="Select Brand" :maxSelectedLabels="1" :selectionLimit="1" class="fixed-width">
                                    </MultiSelect>
                                </b-form-group>
                            </div>
                            
                            <div class="col-md-4 col-12">
                                <!-- <b-form-group id="input-group-2" label="Brand Picture:" label-for="image">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                        <div v-if="editedUser.image"> 
                                        <img :src="'https://wossdb.wossautoid.com/' + image
                                            " alt="Picture" style="max-width: 100px; max-height: 100px" />
                                        <input type="file" accept="image/*" id="image"
                                            @change="onProfilePictureChange" />
                                        </div>
                                        <div v-else>
                                        <span>No image available</span>
                                      </div>  
                                    </div>
                                </b-form-group> -->
                                <b-form-group
                                label="Model Picture:"
                                label-class="font-weight-bold"
                                description="Recommended size: 300x300px (JPG/PNG)"
                                >
                                <!-- Current image -->
                                <div v-if="editedUser.image && !imagePreview" class="mb-2">
                                    <small class="text-muted">Current image:</small><br />
                                    <img
                                    :src="'https://wossdb.wossautoid.com/' + editedUser.image"
                                    alt="Current Picture"
                                    class="img-thumbnail"
                                    style="max-height: 120px;"
                                    />
                                </div>

                                <!-- Upload Area -->
                                <div
                                    class="border rounded p-3 text-center"
                                    style="cursor: pointer; background: #f9f9f9;"
                                    @drop.prevent="onImageDrop"
                                    @dragover.prevent
                                    @click="$refs.profileInput.click()"
                                >
                                    <div v-if="!imagePreview">
                                    <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                    <p class="mb-0">Drag & Drop or Click to Upload</p>
                                    </div>
                                    <div v-else>
                                    <img
                                        :src="imagePreview"
                                        alt="Preview"
                                        class="img-thumbnail"
                                        style="max-height: 120px;"
                                    />
                                    </div>
                                    <input
                                    ref="profileInput"
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    class="d-none"
                                    @change="onProfilePictureChange"
                                    />
                                </div>

                                <small class="text-muted">Leave empty to keep current image</small>
                                <b-form-invalid-feedback
                                    v-if="profileError"
                                    class="d-block text-danger"
                                >
                                    {{ profileError }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                        </div>

                        <!-- Bank Information End -->
                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>
                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
            <code class="hljs html">
              {{ codeText }}
            </code>
          </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
} from "bootstrap-vue";
// import axios from "axios";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";
import MultiSelect from "primevue/multiselect";

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            selectedOption: "",
            inputField1: "",
            inputField2: "",
            inputField3: "",
            showModal: false,
            isLoading: false,
            brand_id: [],
            brands: [],    
            title: "",
            image: "",
             // Previews & errors
            imagePreview: null,
            profileError: "",
            successMessage: "",
            editedUser: {},


        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormSelect,
        BFormInput,
        BToast, // Add this line
        BSpinner,
        MultiSelect,
    },

    created() {
        // Load the clients data when the component is created
        const userId = this.$route.params.id;
        axios
            .get(`brandModelShow/${userId}`)
            .then((response) => {

                this.editedUser = response.data.data;
                this.title = this.editedUser.title;
                this.brand_id = this.editedUser.brand_id ? [this.editedUser.brand_id] : [];
                this.image = this.editedUser.image ||'';
            
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    },
        mounted() {
                    axios.get('brandList')
                        .then(response => {
                            this.brands = response.data.data.map(brand => ({
                                value: brand.id,
                                text: brand.name_with_category
                                    || (brand.category && brand.category.title
                                        ? `${brand.name} - ${brand.category.title}`
                                        : brand.name)
                            }));
                        })
                        .catch(error => {
            
                        });
                },

    methods: {
          validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },
      
        addUser() {
            this.isLoading = true;
            // Create a FormData object to handle the image file

            const formData = new FormData();
            formData.append("title", this.title);
    
            if (this.image instanceof File) {
                formData.append("image", this.image);
            }
            formData.append("brand_id", this.brand_id[0] || "");
         
            axios
                .post(`brandModelUpdate/${this.editedUser.id}`, formData)
                .then((response) => {
                    this.$bvToast.toast("Model Update successfully!", {
                        title: "Success",
                        variant: "primary",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });
                    this.isLoading = false;
                    this.$router.push({ name: 'ListModel' });
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    this.isLoading = false;
                });
        },

        onProfilePictureChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        if (!["image/jpeg", "image/png"].includes(file.type)) {
            this.profileError = "Only JPG/PNG allowed.";
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            this.profileError = "Max size is 5MB.";
            return;
        }

        this.image = file;
        this.imagePreview = URL.createObjectURL(file);
        this.profileError = "";
        },

        onImageDrop(e) {
        const file = e.dataTransfer.files[0];
        this.onProfilePictureChange({ target: { files: [file] } });
        },

        codeClick() {
        this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
    },
};
</script>
<style>
.fixed-width {
  width: 100%;
  border-radius: 6px;
}
.b-form-group > label {
  font-weight: bold !important;
}
</style>